var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-chart"},[(!_vm.failed)?_c('div',{staticClass:"block-chart__canvas-box",attrs:{"aria-hidden":"true"}},[_c('canvas',{ref:"canvas"})]):_vm._e(),_vm._v(" "),_c('chat-table-block',{class:{ 'block-chart__sr-only': !_vm.failed },attrs:{"table":_vm.accessibleTable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }